var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice_detail"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.activityDetail.noticeTitle))]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.activityDetail.scope)}}),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm._f("filterTime")(_vm.activityDetail.createDate)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }